module.exports = __webpack_public_path__ + "static/media/business-philosophy-img1.91cd6f9d.png";